import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import styles from "./style.module.scss";
import ProviderInvoiceInventoryForm from "@components/forms/ProviderInvoiceInventoryForm";

const ProviderInvoiceAddWithInventory = () => {

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={`Agregar Factura de Provedor y agregar inventario`}
      backUrl="/user/provider-invoices"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "providerInvoiceForm",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <ProviderInvoiceInventoryForm
        formId="providerInvoiceForm"
        saveRedirectUrl="/user/provider-invoices"
      ></ProviderInvoiceInventoryForm>

    </PageContainer>
  );
}

export default ProviderInvoiceAddWithInventory;
